import { CustomError } from 'ts-custom-error'

export class BabylonError extends CustomError {}

export class MissingCameraError extends BabylonError {
  message =
    'A camera is required to render the scene. Please setup a camera first.'
}

export class MissingCanvasError extends BabylonError {
  message =
    'A canvas is required to render the scene. Please assign a canvas element to the 3D context first.'
}

export class MissingSceneError extends BabylonError {
  message =
    'A scene is required to add model asset. Please assign a scene to the 3D context first.'
}

export class MissingModelError extends BabylonError {
  message = 'Missing model object. Please check model path/url.'
}
